module.exports = __webpack_public_path__ + "static/media/4.005d3334.jpeg";